import * as React from "react";
import {Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Button} from 'react-bootstrap';

interface CutErrorModalProps {
    errors: string[],
    close(): void
}

/**
 * Display errors when cutting an object is denied.
 */
export default class CutErrorModal extends React.Component<CutErrorModalProps, {}> {

    constructor(props: CutErrorModalProps, context: any) {
        super(props, context);
    }

    render() {
        const errors = this.props.errors.map((error) => <li key={error}>{error}</li>);

        return <Modal show={true} onHide={this.props.close}>
            <ModalHeader>
                <ModalTitle>Kan ikke klippe vegobjekt</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <ul>
                    {errors}
                </ul>
            </ModalBody>
            <ModalFooter>
                <Button bsStyle="default" onClick={this.props.close}>OK</Button>
            </ModalFooter>
        </Modal>;
    }
}
